import { getStore } from "app/store/store"
import { FORECAST_ORDER_NAME, IOrder } from "order/model"
import { orderRPO } from "order/repository"
import { getUserId } from "user/tools/common"

export async function createForecastOrder(): Promise<IOrder> {
  return await orderRPO.createOrder({
    name: FORECAST_ORDER_NAME,
    user_id: getUserId()
  })
}

export function getForecastOrder(): IOrder {
  return getStore().getState().order.forecastOrder
}
